export default {
      id: "sli-down-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-down",
      toString: function () {
        return this.url;
      }
    }